import styles from "./AppOsef.module.css";

export function AppOsefBar() {
  return <label className={styles.AppOsefBar}>|</label>;
}
